import 'trackjs';
import { getEmbedSearchWidgetIdFromPathname } from '#/modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';
import { bootstrapSnippets } from '#/snippets/bootstrap-snippets';
import { getAnalyticsApplicationContextProps } from '#/utils/analytics/helpers/getAnalyticsApplicationContextProps';
import { registerMixpanelProperties } from '#/utils/analytics/helpers/mixpanel';
import { configureAnalyticsUserData } from '#/utils/analytics/setup/configureAnalyticsUserData';
import { configureTrackJs } from '#/utils/configureTrackJs';
import { initXMLHttpRequestActiveCounter } from '#/utils/http/initXMLHttpRequestActiveCounter';
import { trackError } from '#/utils/trackError';
import { trackReferrals } from '#/utils/trackReferral';

export function renderingBootstrapClient() {
  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );

  registerMixpanelProperties(getAnalyticsApplicationContextProps());

  if (embedSearchWidgetId)
    registerMixpanelProperties({ embed_search_widget_id: embedSearchWidgetId });

  if (window.Idealist.appConstants.debugXhr) {
    initXMLHttpRequestActiveCounter();
  }

  const {
    locale,
    initUserEnvironment: { user, environment },
    errorsBeforeTrackJsInstalled,
    trackErrorBeforeTrackJs,
  } = window.Idealist;

  if (errorsBeforeTrackJsInstalled && trackErrorBeforeTrackJs) {
    errorsBeforeTrackJsInstalled.forEach((error) => trackError(error));
    window.removeEventListener('error', trackErrorBeforeTrackJs);
  }

  // Tracking
  configureTrackJs(user ? user.id : null);
  configureAnalyticsUserData({ user, environment, locale });

  trackReferrals();
  bootstrapSnippets();
}
